import { useMemo } from 'react';
import { useStorageState } from 'react-storage-hooks';

import { CONSTANTS } from '../../../core/config/constants';

export interface Props {
  columnsPresetStorageId?: string;
}

interface PresetStorage {
  ids: string[];
  version: string;
}

const version = CONSTANTS.COLUMNS_PRESET_STORAGE.VERSION;
const defaultState = {
  ids: [],
  version,
};

export const useColumnsPresetStorage = ({ columnsPresetStorageId }: Props) => {
  const storageKey = CONSTANTS.COLUMNS_PRESET_STORAGE.KEY_PREFIX + columnsPresetStorageId;
  const [presetStorage, setPresetStorage] = useStorageState<PresetStorage>(
    // don't change sessionStorage to localStorage
    // it's causes browser freezes due to multiple subscribers to the shared storage
    sessionStorage,
    storageKey,
    defaultState,
  );
  const onPresetChanged = (ids: string[]) => {
    setPresetStorage({ ids, version });
  };

  if (!columnsPresetStorageId && localStorage.getItem(storageKey)) {
    localStorage.removeItem(storageKey);
  }

  const storedPresetColumns = useMemo(() => {
    if (columnsPresetStorageId && presetStorage.version === version) {
      return presetStorage?.ids;
    } else {
      setPresetStorage(defaultState);
      return [];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [presetStorage]);

  return {
    storedPresetColumns,
    storePresetColumns: columnsPresetStorageId ? onPresetChanged : () => {},
  };
};
